module.exports = __webpack_public_path__ + "static/img/rcg_left.8364eb3.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/rcg_left.png
// module id = UeCc
// module chunks = 0